import { Component, Inject, Optional } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

export type ReasonCodeAndDescription = {
  code: string;
  description: string;
};

@Component({
  selector: 'jfw-wholesale-potential-events-rejection-modal',
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './rejection-modal.component.html',
  styleUrls: ['./rejection-modal.component.scss'],
})
export class WholesalePotentialEventsRejectionModalComponent {
  reasonForm: FormGroup;
  reasonCodes: ReasonCodeAndDescription[] = [
    { code: 'I', description: 'Not a valid event' },
    { code: 'C', description: 'Event has been cancelled' },
    { code: 'N', description: 'Do not wish to service this event' },
    { code: 'O', description: 'Other' },
  ];

  constructor(
    public dialogRef: MatDialogRef<WholesalePotentialEventsRejectionModalComponent>,
    private fb: FormBuilder,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: { showNewDesign?: boolean } | null,
  ) {
    this.reasonForm = this.fb.group({
      reasonCode: ['', Validators.required],
      description: [{ value: '', disabled: true }],
    });

    this.reasonForm.get('reasonCode')?.valueChanges.subscribe((value) => {
      console.log('Reason code changed:', value);
      const descriptionControl = this.reasonForm.get('description');
      if (value === 'O') {
        descriptionControl?.enable();
        descriptionControl?.setValidators(Validators.required);
      } else {
        descriptionControl?.disable();
        descriptionControl?.clearValidators();
      }
      descriptionControl?.updateValueAndValidity();
    });
  }

  onConfirm(): void {
    if (this.reasonForm.valid) {
      const reasonCodeAndDescription: ReasonCodeAndDescription = {
        code: this.reasonForm.value.reasonCode,
        description: this.reasonForm.value.description || '',
      };

      if (this.reasonForm.value.reasonCode !== 'O') {
        reasonCodeAndDescription.description = this.getDescription(
          this.reasonForm.value.reasonCode,
        );
      }
      this.dialogRef.close(reasonCodeAndDescription);
    }
  }

  // Write a function that gets the description if the reason code is not 'O'
  getDescription(reasonCode: string): string {
    console.log('Getting description for reason code:', reasonCode);
    const reason = this.reasonCodes.find((r) => r.code === reasonCode);
    console.log('Found reason:', reason);
    return reason ? reason.description : '';
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
